import { render, staticRenderFns } from "./ConfigartionListNumbers.vue?vue&type=template&id=3a09f070&"
import script from "./ConfigartionListNumbers.vue?vue&type=script&lang=js&"
export * from "./ConfigartionListNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports